import { CoopMembershipConfirmation } from "Components/Form/Partner/coopFormComponents/CoopMembershipConfirmation";
import { HuseierneMembershipStatusFormElements } from "Components/Form/Partner/huseierneFormComponents/HuseierneMembershipStatusFormElements";
import { useBrandingTheme } from "Store/partners/partnerHooks";
import { Partner } from "Store/partners/partnerInterfaces";
import { useFormikContext } from "formik";
import React from "react";

interface Props {
  readonly isWithSurface?: boolean;
}

export const PartnerProductIntroForms = ({
  isWithSurface = false,
}: Props): React.ReactElement | null => {
  const formProps = useFormikContext();
  const brandingThemeId = useBrandingTheme().id;
  const isCoopTheme = brandingThemeId === Partner.COOP;
  const isHuseierneTheme = brandingThemeId === Partner.HUSEIERNE;

  if (isCoopTheme) {
    return (
      <div className="data-hj-suppress">
        <CoopMembershipConfirmation
          formProps={formProps}
          isWithSurface={isWithSurface}
        />
      </div>
    );
  }

  if (isHuseierneTheme) {
    return (
      <div className="data-hj-suppress">
        <HuseierneMembershipStatusFormElements formProps={formProps} />;
      </div>
    );
  }

  return null;
};
